"use client";
import React from "react";
import { cn } from "../../../../../../lib/utils";
import { useSlugNodeClassName } from "../../utils/use-slug-node-class";
import { buildClassNameFromProps } from "../../utils/class-tokens";

const CONTAINER_CLASS_PROPS = [
    "display",
    "flexDirection",
    "align",
    "alignContent",
    "justify",
    "wrap",
    "rowGap",
    "columnGap",
    "textAlign",
    "width",
    "maxWidth",
    "minWidth",
    "height",
    "minHeight",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "borderType",
    "borderRadius",
    "position",
    "backgroundColor",
    "backgroundImageSize",
    "backgroundImagePosition",
    "backgroundImageRepeat",
    "zIndex",
    "overflow",
    "boxSizing",
    "flexGrow",
    "flexShrink",
    "flexBasis",
    "alignSelf",
    "order",
];

function buildClassName(props) {
    return cn(buildClassNameFromProps(props, CONTAINER_CLASS_PROPS));
}

export default function Container({ children, ...props }) {
    const nodeClassName = useSlugNodeClassName();
    const className = cn(nodeClassName, buildClassName(props));

    return (
        <div className={className}>
            {children}
        </div>
    );
}

Container.craft = {
    props: {
        display: "flex",
        flexDirection: "flex-col",
        minWidth: "min-w-0",
        contentWidth: "boxed",
        width: "w-full",
        maxWidth: "max-w-[1140px]",
        paddingTop: "pt-4",
        paddingRight: "pr-4",
        paddingBottom: "pb-4",
        paddingLeft: "pl-4",
        position: "relative",
        flexGrow: "grow-0",
        flexShrink: "shrink",
        flexBasis: "basis-auto",
        overflow: "overflow-visible",
        wrap: "flex-wrap",
        locked: false,
        boxSizing: "box-border",
        alignSelf: "self-center",
        backgroundType: "none",
        backgroundSolidColor: "#ffffff",
        backgroundSolidOpacity: 1,
        backgroundGradientDirection: "to bottom",
        backgroundGradientStart: "#274067",
        backgroundGradientStartOpacity: 1,
        backgroundGradientEnd: "#000000",
        backgroundGradientEndOpacity: 1,
        backgroundImageUrl: "",
        backgroundImageSize: "cover",
        backgroundImagePosition: "center",
        backgroundImageRepeat: "no-repeat",
        backgroundImageFallbackColor: "#ffffff",
        backgroundImageFallbackOpacity: 1,
        backgroundOverlayEnabled: false,
        backgroundOverlayDirection: "to bottom",
        backgroundOverlayStart: "#000000",
        backgroundOverlayStartOpacity: 0.4,
        backgroundOverlayEnd: "#000000",
        backgroundOverlayEndOpacity: 0.4,
        marginLocked: true,
    },
};
